import { render, staticRenderFns } from "./marketing-rules.vue?vue&type=template&id=35030300&scoped=true"
import script from "./marketing-rules.vue?vue&type=script&lang=js"
export * from "./marketing-rules.vue?vue&type=script&lang=js"
import style0 from "./marketing-rules.vue?vue&type=style&index=0&id=35030300&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35030300",
  null
  
)

export default component.exports